<template>
    <div class="ibox select-services-dropdown" id="serviceSection_div">
        <div :class="{'ibox-content mobile-service-ibox-content':true,'no-padding':viewPage}"  style="border: none">

            <p class="font-size-18 bold " style="margin-top: 15px">
                <span class="select-services-dropdown-title">Services</span>
                <span class="float-right" v-if="isMobile">
                    <a href="javascript:;" data-toggle="modal" data-target="#services-modal-mobile-view">
                        <span class="select-services-dropdown-add-label float-left">Add</span>
                       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                            fill="#03A9F4"/>
                      </svg>
                    </a>
                </span>
                <!--                this button will appear on the web only if there is one or more service selected-->
                <span class="float-right" v-if="!isMobile && ( showAddServiceButton  || this.isEdit == 1)">
                      <a href="javascript:;" @click="showUpperSelectServiceInputSection">
                          <span class="select-services-dropdown-add-label float-left">Add</span>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                            fill="#03A9F4"/>
                      </svg>
                      </a>
                  </span>

                <span :class="{'float-right':!isMobile}" v-if="serviceChanged">
                    <a
                       :class="{'save_booking_btn col-md-6 width_of_icon_search btn btn-primary border_color translate_save_button_tab octopus-btn-default octopus-btn-default-mobile':true,'bottom-12':!isMobile}"
                       href="javascript:void(0);">Save changes</a>
                </span>
            </p>

            <select-services-dropdown id="selectServiceDropDown" style="margin-top: 25px" :from="from" :currency="currency"  :booking="booking"
                                      v-if="!isMobile"></select-services-dropdown>

            <!--             selected services will apeear here -->
            <div id="selectedServices" style="margin-top: 25px;"></div>
            <!-- Modal -->
            <div class="modal fade modal-fullscreen" id="services-modal-mobile-view" tabindex="-1" role="dialog"
                 aria-labelledby="services-modal-mobile-view" v-if="isMobile">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="display-inline-block"></h3>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                                aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="modal-body" style="height: 100px">
                            <div class="row">
                                <select-services-dropdown :from="from"
                                                          :currency="currency"
                                                          :booking="booking"
                                                          parent="#services-modal-mobile-view-body"
                                                          :isMobile="isMobile"
                                ></select-services-dropdown>
                                <a href="/settings/services/add" target="_blank" style="float: right">
                                    <svg width="20" height="20" class="addNewService_mobile_svg m-right-20"
                                         style="fill: #2E4051; display: inline; position:relative; left: -10px; top: -55px;z-index: 9999"
                                         viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                                            fill="#03A9F4"/>
                                    </svg>
                                </a>

                            </div>
                        </div>
                        <div id="services-modal-mobile-view-body"></div>
                    </div>
                </div>
            </div>
            <!-- End Modal -->
        </div>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
export default {
    name: "selectServices",
    props: ['currency','isEdit', 'from','viewPage','serviceChanged','booking'],
    computed: {
        isMobile() {
            return this.getWidth() < 460;
        }
    },
    data() {
        return {
            showAddServiceButton: 0,
        }
    },
    methods: {
        getWidth() {
            let xWidth = null;
            if (window.screen != null)
                xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
                xWidth = window.innerWidth;

            if (document.body != null)
                xWidth = document.body.clientWidth;

            return xWidth;
        },
        showUpperSelectServiceInputSection() {
            EventBus.$emit('onAddAnotherService',this.isEdit);
        },
      loadScript(url, callback) {
        var list = document.getElementsByTagName('script');
        //Search for tinymce.min.js if already loaded before in the page
        var i = list.length, flag = false;
        while (i--) {
          if (list[i].src === url && list[i].dataset.loaded) {
            flag = true;
            break;
          }
        }
        //if we load tinymce.min.js more than once after it's already loaded (in case ajax) it not init new ones
        // if we didn't already find it on the page, add it
        if (!flag) {
          var script = document.createElement("script")
          script.type = "text/javascript";

          if (script.readyState) {  // only required for IE <9
            script.onreadystatechange = function () {
              if (script.readyState === "loaded" || script.readyState === "complete") {
                script.onreadystatechange = null;
                script.dataset.loaded = true;
                callback();
              }
            };
          } else {  //Others
            script.onload = function () {
              script.dataset.loaded = true;
              callback();
            };
          }
          script.src = url;
          document.getElementsByTagName("head")[0].appendChild(script);
        } else {
          callback();
        }

      },
    },
    mounted() {
        let vm = this;
        let convert_to_inquiry = window.location.href.includes("inquiry_id");
        this.$nextTick(() => {
            $('#selectedServices').sortable({
                handle: '.drag-tool',
                stop: function (event, ui) {
                    EventBus.$emit('onSortableEnd');
                },
                start: function (event, ui) {
                    EventBus.$emit('onSortableStart');
                }
            });
        }),

        $('#services-modal-mobile-view').on('shown.bs.modal', function () {
            $('#tomselect-5-ts-control').focus();
        })

        setTimeout(function () {
            // to draw exist services data in this component
            //This commented code corrupt tinymc editor
            // let selectedServicesExisted = $('#selectedServicesExisted');
            // let selectedServicesExistedContent = selectedServicesExisted.html();
            // $('#selectedServices').html(selectedServicesExistedContent)
            // selectedServicesExisted.html('');

            if (vm.isEdit == 1 || convert_to_inquiry) {
                let minusIcon = $('.plus-minus-injected > .input-group-append .bootstrap-touchspin-injected')
                let plusIcon = $('.plus-minus-injected > .input-group-prepend .bootstrap-touchspin-injected')
                let text = $('.plus-minus-injected span.bootstrap-touchspin-injected')

                minusIcon.remove()
                plusIcon.remove()
                text.remove()
            }
        }, 2000);

    }
}
</script>

<style scoped lang="scss">
@mixin modal-fullscreen() {
    padding: 0 !important; // override inline padding-right added from js

    .modal-dialog {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
    }

    .modal-content {
        height: auto;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
    }
    .drag-tool{
      cursor: grab;
    }

}

@media (max-width: 767px) {
    .modal-fullscreen-xs-down {
        @include modal-fullscreen();
    }
}

@media (max-width: 991px) {
    .modal-fullscreen-sm-down {
        @include modal-fullscreen();
    }
}

@media (max-width: 1199px) {
    .modal-fullscreen-md-down {
        @include modal-fullscreen();
    }
}

.modal-fullscreen {
    @include modal-fullscreen();
}

.fa-question-circle {
    color: #CBCFD3;
}
.left-20{
    left: 20px;
}
.bottom-12{
    bottom: 12px;
}
#services-modal-mobile-view-body {
    //min-height: 600px !important;
    height: auto !important;
}

@media (max-width: 768px) {
    .mobile-service-ibox-content {
        padding-right: 0px !important;
        padding-left: 0px !important;
        padding-bottom: 0px !important;
    }
}

@media (max-width: 468px) {
    .mobile-service-ibox-content {
        padding-right: 8px !important;
        padding-left: 8px !important;
    }
}

</style>
<style scoped>
.ui-sortable{
  cursor: default !important;
}
</style>